import { action } from 'app/actions';

export const GET_INFO = 'reports/GET_INFO';
export const getInfo = (payload) => action(GET_INFO, { payload });

export const GET_GROUPS = 'reports/GET_GROUPS';
export const getGroups = (payload) => action(GET_GROUPS, { payload });

export const GET_GENERAL_PAINEL_FILTERS = 'reports/GET_GENERAL_PAINEL_FILTERS';
export const getGeneralPainelFilters = (payload) => action(GET_GENERAL_PAINEL_FILTERS, { payload });

export const GET_ESGRADE_GENERAL = 'reports/GET_ESGRADE_GENERAL';
export const getESGradeGeneral = (payload) => action(GET_ESGRADE_GENERAL, { payload });

export const GET_ESGRADE_BY_RANKING_STUDENT = 'reports/GET_ESGRADE_BY_RANKING_STUDENT';
export const getESGradeByRankingStudent = (payload) =>
  action(GET_ESGRADE_BY_RANKING_STUDENT, { payload });

export const GET_ESGRADE_BY_DISCIPLINE = 'reports/GET_ESGRADE_BY_DISCIPLINE';
export const getESGradeByDiscipline = (payload) => action(GET_ESGRADE_BY_DISCIPLINE, { payload });

export const GENERATE_PDF = 'reports/GENERATE_PDF';
export const generatePdf = (payload) => action(GENERATE_PDF, { payload });

export const GENERATE_BATCH_PDF = 'reports/GENERATE_BATCH_PDF';
export const generateBatchPdf = (payload) => action(GENERATE_BATCH_PDF, { payload });

export const GENERATE_EVALUATION_ANSWER_SHEET_FILES_STATUS =
  'simulated/edition/GENERATE_EVALUATION_ANSWER_SHEET_FILES_STATUS';
export const generateEvaluationAnswerSheetsFilesStatus = (payload) =>
  action(GENERATE_EVALUATION_ANSWER_SHEET_FILES_STATUS, { payload });

export const GET_STUDENTS_ANSWERS_QUESTION_REPORT =
  'reports/general-panel/GET_STUDENTS_ANSWERS_QUESTION_REPORT';

export const GET_ES_GRADE_COMPARATIVE_BY_DISCIPLINE =
  'reports/general-panel/GET_ES_GRADE_COMPARATIVE_BY_DISCIPLINE';

export const GET_ES_GRADE_COMPARATIVE_GENERAL =
  'reports/general-panel/GET_ES_GRADE_COMPARATIVE_GENERAL';

export const GET_ES_QUESTIONS_DETAILS_BY_COMPARATIVE =
  'reports/general-panel/GET_ES_QUESTIONS_DETAILS_BY_COMPARATIVE';

export const getStudentsAnswersQuestionReport = (payload) =>
  action(GET_STUDENTS_ANSWERS_QUESTION_REPORT, { payload });

export const getESGradeComparativeByDiscipline = (payload) =>
  action(GET_ES_GRADE_COMPARATIVE_BY_DISCIPLINE, { payload });

export const getESGradeComparativeGeneral = (payload) =>
  action(GET_ES_GRADE_COMPARATIVE_GENERAL, { payload });

export const getESQuestionsDetailsByComparative = (payload) =>
  action(GET_ES_QUESTIONS_DETAILS_BY_COMPARATIVE, { payload });
